"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../Graphics/Icon/Icon"));

var _Paragraph = _interopRequireDefault(require("../../Typography/Paragraph/Paragraph"));

var _Colors = _interopRequireDefault(require("../../Basic/Colors/Colors"));

require("./Notification.css");

var _icon_warning = _interopRequireDefault(require("./svg/icon_warning"));

var _icon_success = _interopRequireDefault(require("./svg/icon_success"));

var _icon_info = _interopRequireDefault(require("./svg/icon_info"));

var _core = require("@material-ui/core");

var _excluded = ["open", "message", "type", "onClose"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @visibleName Global Notifications
 */
function Notification(_ref) {
  var open = _ref.open,
      message = _ref.message,
      type = _ref.type,
      onClose = _ref.onClose,
      rest = _objectWithoutProperties(_ref, _excluded);

  var styles = {
    backgroundColor: Notification.backgroundColors[type] || _Colors.default.sinineVaal,
    color: '#fff'
  };
  return /*#__PURE__*/_react.default.createElement(_core.Snackbar, _extends({
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    open: open,
    autoHideDuration: 6000,
    onClose: onClose
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "notification",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("div", null, NotificationIcon({
    type: type
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Paragraph.default, {
    fontSize: "14B",
    color: styles.color
  }, message)), /*#__PURE__*/_react.default.createElement("div", {
    className: "icon-special-color",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: "times",
    color: styles.color
  }))));
}

Notification.propTypes = {
  /** Opened state */
  open: _propTypes.default.bool.isRequired,

  /** Text message */
  message: _propTypes.default.string,

  /** Close handler */
  onClose: _propTypes.default.func.isRequired,

  /** The type of the Notification */
  type: _propTypes.default.oneOf(['info', 'success', 'warning'])
};
Notification.defaultProps = {
  type: 'info'
};
Notification.backgroundColors = {
  info: _Colors.default.sinineVaal,
  success: _Colors.default.maismaa,
  warning: _Colors.default.hapumarjapuu
};
var _default = Notification;
exports.default = _default;

function NotificationIcon(_ref2) {
  var type = _ref2.type;

  switch (type) {
    case 'info':
      return /*#__PURE__*/_react.default.createElement(_icon_info.default, null);

    case 'success':
      return /*#__PURE__*/_react.default.createElement(_icon_success.default, null);

    case 'warning':
    default:
      return /*#__PURE__*/_react.default.createElement(_icon_warning.default, null);
  }
}